import { render, staticRenderFns } from "./kesenkisirapor.vue?vue&type=template&id=396a1c9d&scoped=true&"
import script from "./kesenkisirapor.vue?vue&type=script&lang=js&"
export * from "./kesenkisirapor.vue?vue&type=script&lang=js&"
import style0 from "./kesenkisirapor.vue?vue&type=style&index=0&id=396a1c9d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396a1c9d",
  null
  
)

export default component.exports